enum AiTrackingType {
  Before = 'Before',
  After = 'After',
  BeforeAndAfter = 'Before And After'
}

enum TrackingType {
  After = 0,
  BeforeAndAfter = 1,
  Before = 2,
}

export {TrackingType, AiTrackingType};